import React from 'react'
import { IStudyPlan } from 'store/modules/studyPlan/types'
import CycleDashboard from './dashboard/cycle'
import './styles.css'

interface PlanViewerProps {
  plan: IStudyPlan | null
  loading: boolean
  isDarkMode?: boolean
}

/**
 * Componente para visualização do plano de estudos
 * Renderiza o dashboard apropriado baseado no tipo do plano
 */
const PlanViewer: React.FC<PlanViewerProps> = ({ plan, loading, isDarkMode = false }) => {
  if (loading) {
    return (
      <div className={`plan-viewer-container ${isDarkMode ? 'dark' : 'light'}`}>
        <div className="loading-block" style={{ width: '100%', height: 60 }} />
        <div className="loading-block" style={{ width: '100%', height: 40, marginTop: 20 }} />
        <div className="loading-block" style={{ width: '100%', height: 200, marginTop: 20 }} />
      </div>
    )
  }

  if (!plan) {
    return (
      <div className={`plan-viewer-container ${isDarkMode ? 'dark' : 'light'}`}>
        <div className="plan-viewer-empty">
          <h2 className="plan-viewer-title">Nenhum plano selecionado</h2>
          <p className="plan-viewer-subtitle">Crie um novo plano ou selecione um existente</p>
        </div>
      </div>
    )
  }

  // Renderiza dashboard baseado no tipo do plano
  const renderDashboard = () => {
    switch (plan.type) {
      case 'cycle':
        return <CycleDashboard plan={plan} isDarkMode={isDarkMode} />

      case 'schedule':
        // TODO: Implementar ScheduleDashboard
        return (
          <div className="plan-viewer-placeholder">
            <div className="plan-viewer-placeholder-content">
              <p className="plan-viewer-placeholder-title">📅 Cronograma Semanal</p>
              <p className="plan-viewer-placeholder-description">
                Dashboard para cronograma semanal será implementado em breve.
              </p>
            </div>
          </div>
        )

      default:
        return (
          <div className="plan-viewer-placeholder">
            <div className="plan-viewer-placeholder-content">
              <p className="plan-viewer-placeholder-title">⚠️ Tipo de plano não suportado</p>
              <p className="plan-viewer-placeholder-description">
                O tipo de plano "{plan.type}" ainda não é suportado.
              </p>
            </div>
          </div>
        )
    }
  }

  return (
    <div className={`plan-viewer-container ${isDarkMode ? 'dark' : 'light'}`}>
      {renderDashboard()}
    </div>
  )
}

export default PlanViewer
